module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissionmanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("权限组管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("新增权限组")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "400px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("权限组名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入权限组名称"
    },
    model: {
      value: (_vm.newpermissionname),
      callback: function($$v) {
        _vm.newpermissionname = $$v
      },
      expression: "newpermissionname"
    }
  })], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.newpermission
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "margin-bottom": "10px"
    }
  }, [_vm._v("权限组选择")]), _vm._v(" "), _c('a-cascader', {
    attrs: {
      "allowClear": false,
      "options": _vm.options,
      "placeholder": "请选择权限组..."
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "margin": "10px 0"
    }
  }, [_vm._v("权限组功能选择")]), _vm._v(" "), _c('a-tree', {
    attrs: {
      "checkable": "",
      "treeData": _vm.treeData
    },
    on: {
      "check": _vm.onCheck
    },
    model: {
      value: (_vm.checkedKeys),
      callback: function($$v) {
        _vm.checkedKeys = $$v
      },
      expression: "checkedKeys"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.checkedKeys
    },
    on: {
      "click": _vm.savepermission
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t确定\n\t\t\t\t\t\t")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px",
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.checkedKeys,
      "ghost": ""
    },
    on: {
      "click": function () {
        this$1.groupChange(this$1.checkedKeys);
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t取消\n\t\t\t\t\t\t")])], 1)], 1)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d93c76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/usermanagement/permissionmanagement/index.vue
// module id = 2366
// module chunks = 1